<template>
  <q-page padding>
    <PageHeader
      title="Novo Treinamento"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>

        <lista-unidades-select v-model="unidade.nome"></lista-unidades-select>
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Nome do Treinamento</div>
        <q-input v-model="dados.nomeTreinamento" dense outlined class="input" />
      </div>
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Descrição</div>
        <q-input
          v-model="dados.descricaoTreinamento"
          dense
          outlined
          class="input"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Validade</div>
        <q-input
          v-model="dados.validade"
          dense
          outlined
          placeholder="Dias"
          class="input"
        />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm btn"
          label="Criar"
          icon="add"
          color="positive"
          @click="criarTreinamento()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela text-brand-5 text-subtitle1 text-weight-bold"
        >
          Lista de Treinamentos
        </span>
        <div
          class="row col-12 justify-end text-brand-5 text-weight-bold q-mb-lg container-input-search"
        >
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="dados.treinamento"
            type="text"
            class="col-md-3 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-table
        :columns="columns"
        :rows="listaTreinamentos"
        :loading="loading"
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        class="tabela-tamanho-fixo"
        dense
        :grid="$q.screen.lt.sm"
        :rows-per-page-options="[0]"
        hide-pagination
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-7">
                  <div class="row col-12 q-ml-sm q-mt-sm">
                    <span class="q-mr-sm"
                      ><strong class="q-mr-xs">Nome: </strong>
                      {{ props.row.nome }}</span
                    >
                  </div>
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Descrição: </strong>
                    {{ props.row.descricao }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Validade do Treinamento: </strong>
                    {{
                      props.row.validade == 1
                        ? `${props.row.validade} Dia`
                        : `${props.row.validade} Dias`
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Num. Pessoas: </strong>
                    {{ props.row.quantidadeFuncionarios }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Num. Grupos Produtos: </strong>
                    {{ props.row.quantidadeGrupos }}</span
                  >
                </div>
                <div class="col-5">
                  <div class="row col-12 q-gutter-x-sm">
                    <q-btn
                      color="blue-6"
                      round
                      size="md"
                      icon="newspaper"
                      @click="configurarCertificado(props.row.id)"
                    />
                    <q-btn
                      color="blue-6"
                      round
                      size="md"
                      icon="group_add"
                      @click="detalharTreinamentoPessoa(props.row.id)"
                    />
                    <q-btn
                      color="blue-6"
                      round
                      size="md"
                      icon="groups"
                      @click="detalharTreinamentoGrupo(props.row.id)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.nome }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.descricao }}
          </q-td>
        </template>
        <template v-slot:body-cell-validade="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span>
              {{
                props.row.validade == 1
                  ? `${props.row.validade} Dia`
                  : `${props.row.validade} Dias`
              }}</span
            >
          </q-td>
        </template>
        <template v-slot:body-cell-numeroPessoas="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.quantidadeFuncionarios }}
          </q-td>
        </template>
        <template v-slot:body-cell-numeroGruposProdutos="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.quantidadeGrupos }}
          </q-td>
        </template>
        <template v-slot:body-cell-configurarCertificado="props">
          <q-td :props="props">
            <router-link
              :to="{
                name: 'treinamento-configurar-certificado',
                params: { treinamentoId: props.row.id },
              }"
            >
              <q-btn color="blue-6" round size="sm" icon="newspaper" />
            </router-link>
          </q-td>
        </template>
        <template v-slot:body-cell-editarPessoas="props">
          <q-td :props="props">
            <router-link
              :to="{
                name: 'treinamento-detalhar-pessoas',
                params: { treinamentoId: props.row.id },
              }"
            >
              <q-btn color="blue-6" round size="sm" icon="group_add" />
            </router-link>
          </q-td>
        </template>
        <template v-slot:body-cell-editarGrupos="props">
          <q-td :props="props">
            <router-link
              :to="{
                name: 'treinamento-detalhar-grupos',
                params: { treinamentoId: props.row.id },
              }"
            >
              <q-btn color="blue-6" round size="sm" icon="groups" />
            </router-link>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../../components/PageHeader.vue";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "validade",
    label: "Validade do Treinamento",
    align: "left",
  },
  {
    name: "numeroPessoas",
    label: "Num. Pessoas",
    align: "left",
  },
  {
    name: "numeroGruposProdutos",
    label: "Num. Grupos Produtos",
    align: "left",
  },
  {
    name: "configurarCertificado",
    label: "Config. Certificado",
    align: "center",
  },
  {
    name: "editarPessoas",
    label: "Editar Pessoas",
    align: "center",
  },
  {
    name: "editarGrupos",
    label: "Editar Grupos",
    align: "center",
  },
];
export default {
  components: { ListaUnidadesSelect, PageHeader },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();

    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const dados = ref({
      nomeTreinamento: "",
      validade: "",
      descricaoTreinamento: "",
      treinamento: "",
    });
    const listaTreinamentos = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let disable = ref(false);
    let loading = ref(false);

    const listarTreinamentos = async (page = 0, rowsNumber = 10) => {
      await unidade.value.id;
      try {
        loading.value = true;
        disable.value = true;
        const response = await store.dispatch(
          "treinamento/listarTreinamentos",
          {
            unidadeId: unidade.value.id,
            treinamento: dados.value.treinamento,
            per_page: rowsNumber,
            page: page,
          }
        );
        listaTreinamentos.value = response.data.data;
        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.page = response.data.current_page;
        pagination.value.rowsNumber = response.data.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const criarTreinamento = async () => {
      try {
        await store.dispatch("treinamento/criarTreinamento", {
          descricao: dados.value.descricaoTreinamento,
          nome: dados.value.nomeTreinamento,
          unidadeId: unidade.value.id,
          validade: dados.value.validade,
        });
        quasar.notify({
          message: "Treinamento criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarTreinamentos();
        reset();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao criar treinamento",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const reset = () => {
      dados.value = {
        nomeTreinamento: "",
        descricaoTreinamento: "",
        validade: "",
      };
    };

    const detalharTreinamentoPessoa = (id) => {
      router.push({
        name: "treinamento-detalhar-pessoas",
        params: { treinamentoId: id },
      });
    };

    const detalharTreinamentoGrupo = (id) => {
      router.push({
        name: "treinamento-detalhar-grupos",
        params: { treinamentoId: id },
      });
    };

    const configurarCertificado = (id) => {
      router.push({
        name: "treinamento-configurar-certificado",
        params: { treinamentoId: id },
      });
    };

    watch(
      () => pagination.value.page,
      () => {
        listarTreinamentos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        listarTreinamentos();
      }
    );

    watch(
      () => dados.value.treinamento,
      () => {
        listarTreinamentos();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    onMounted(listarTreinamentos);

    return {
      columns,
      unidade,
      dados,
      listarTreinamentos,
      listaTreinamentos,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      criarTreinamento,
      reset,
      detalharTreinamentoPessoa,
      detalharTreinamentoGrupo,
      configurarCertificado,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }

  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .btn {
    margin: 0px 0px 0px 0px;
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
}
</style>
